module.exports = __webpack_public_path__ + "static/media/Dark-CorsicaTech_Logo_Color.293a0de4.svg";